<template>
    <div>
        <!-- Page length options -->
        <div class="card mb-0">
            <div v-show="onload" class="content bg-white">
                <placeholder-content isLoad="true" />
            </div>
            <!-- <div v-if="!onload && hasPermission">
                <access-denied></access-denied>
            </div> -->
            <div v-show="!onload" class="card-header  border-bottom">
                <div class="row">
                    <div class="col-6">
                        <h5 class="card-title">{{ $t("Total Sales Details") }}</h5>
                    </div>
                </div>
            </div>
            <div v-show="!onload" class="card-body p-0">
                <div v-show="!onload">
                    <div v-show="!onload" class="flex-wrap pl-3 pt-3">
                        <div class="d-flex flex-wrap">
                            <div class="card mr-3">
                                <div class="card-body">
                                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-shopping-cart"></i></span>
                                    <h6 class="mb-0 font-weight-semibold pr-5">{{ $t("_Shipping.Number of Orders") }}</h6>
                                    <h3 class="text-grey-800 font-weight-semibold my-1">{{ OrderQuantity }}</h3>
                                </div>
                            </div>
                            <div class="card mr-3">
                                <div class="card-body">
                                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-sack-dollar"></i></span>
                                    <h6 class="mb-0 font-weight-semibold pr-5">{{ $t("Total Sales") }}</h6>
                                    <h3 class="text-grey-800 font-weight-semibold my-1">฿{{ totalSales | formatNumber}}</h3>
                                </div>
                            </div>
                            <div class="card mr-3">
                                <div class="card-body">
                                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-calendar-alt"></i></span>
                                    <h6 class="mb-0 font-weight-semibold pr-5">{{ $t("Date Duration") }}</h6>
                                    <h3 class="text-grey-800 font-weight-semibold my-1">{{ paramsQuery.start_date | formatDate }} - {{ paramsQuery.end_date | formatDate }}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-wrap">
                        <div class="position-relative">
                            <div :class="[loading ? 'loading' : '']">
                                <div class="border-top border-bottom">
                                    <div class="btn-group flex-wrap w-100 py-3 px-3 bg-light">
                                        <!-- search -->
                                        <div class="toobar-search pr-2">
                                            <div class="input-group bg-white">
                                                <input type="text" @keydown.enter.prevent="search()" v-model="paramsQuery.search" name="search"
                                                    :placeholder="$t('Search by Order No. , Receiver')" style="min-width: 225px"
                                                    class="border-right-0 form-control pl-2 px-0" />
                                                <span class="input-group-append">
                                                    <button class="btn btn-outline-normal border-left-0 btn-search" type="button"
                                                        @click="search">
                                                        <i class="far fa-search"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                        <!-- perpage -->
                                        <div class="dataTables_length ml-auto mb-0">
                                            <PerPage @per-page="setPerPage" />
                                        </div>
                                    </div>
                                </div>
                                <div :class="['table-responsive mt-0 data-nowrap table-hover table-order']" id="table-order">
                                    <div class="vuetable-wrapper datatable-scroll">
                                        <vuetable :class="[loadingTable]" ref="vuetable" :no-data-template="$t('No Data Available')"
                                            :fields="table.fields" data-path="data" pagination-path="" :api-mode="false"
                                            :data-manager="dataManager" @vuetable:loaded="vuetableLoaded" @vuetable:loading="vuetableLoading"
                                            @vuetable:pagination-data="onPaginationData" @vuetable:initialized="onInitialized">
                                            <template slot="orderNo" slot-scope="props">
                                                <a class="text-primary" :href="'/app/orders/'+props.rowData.id" target="_blank">
                                                    {{ props.rowData.orderNo }}
                                                </a>
                                            </template>
                                            <div slot="payment" slot-scope="props">
                                                <a v-if="props.rowData.payment_method_id == 1" v-tooltip:top="($storeIndex.isset(() => props.rowData.sales_order_payment[0].bank_account.bank.name) ? props.rowData.sales_order_payment[0].bank_account.bank.name : $t('Bank Transfer'))" :data-original-title="($storeIndex.isset(() => props.rowData.sales_order_payment[0].bank_account.bank.name) ? props.rowData.sales_order_payment[0].bank_account.bank.name : $t('Bank Transfer'))">
                                                    <img v-if="$storeIndex.isset(() => props.rowData.sales_order_payment)" :src="bankLogo(props.rowData.sales_order_payment)" class="image_box">
                                                </a>
                                                <a v-if="props.rowData.payment_method_id == 2" v-tooltip:top="$t('COD')" :data-original-title="$t('COD')">
                                                    <img :src="$storeIndex.getImageSrc('payment/cod', '.svg')" class="image_box">
                                                </a>
                                            </div>
                                            <template slot="tableFooter">
                                                <tr>
                                                    <th v-for="(field, indexField) in dataFooterFields" :class="field.dataClass" :key="indexField + '_' + field.visible">
                                                        <template v-if="field.name == 'orderNo'">
                                                            {{ $t('Total Amount') }}
                                                        </template>
                                                        <template v-else-if="field.name == 'qty'">
                                                            {{ totalqty }}
                                                        </template>
                                                        <template v-else-if="field.name == 'totalNormal'">
                                                            {{ totalNormals | formatNumber }}
                                                        </template>
                                                        <template v-else-if="field.name == 'totalSales'">
                                                            {{ totalSale | formatNumber }}
                                                        </template>
                                                    </th>
                                                </tr>
                                            </template>
                                        </vuetable>
                                    </div>
                                </div>
                                <div class="datatable-footer pl-3 pr-3">
                                    <vuetable-pagination-info class="dataTables_info" ref="paginationInfo"
                                        :no-data-template="$t('No relevant data')"
                                        :info-template="$t('Displaying {from} to {to} of {total} items')"></vuetable-pagination-info>
                                    <div class="dataTables_paginate paging_simple_numbers mb-0">
                                        <vuetable-pagination ref="pagination" pagination-path="pagination"
                                            @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Api from "@/services/endpoint/tenant.service";
    import DateRangePicker from "vue2-daterange-picker";
    import PerPage from "../PerPage.vue";
    import Select2 from "v-select2-component";
    import Vuetable from "vuetable-2";
    import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
    import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo";
    import moment from "moment";
    import VueJsCounter from "@/plugins/VueJsCounter";
    import {
        convertTimezone
    } from "@/common/tenancy/convertTimezone";
    import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
    import numeral from 'numeral'
    import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
    import ProductSalesDetailGoship from "../assets/js/product_sales_detail_goship_fields.js";
    export default {
        name: "detail",
        components: {
            DateRangePicker,
            PerPage,
            Select2,
            PlaceholderContent,
            VueJsCounter,
            AccessDenied,
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
        },
        data() {
            return {
                defaultStartDate: moment().subtract(1, 'months').format('YYYY-MM-DD 17:00:00'),
                defaultEndDate: moment().format('YYYY-MM-DD 16:59:59'),
                onload: true,
                hasPermission: true,
                loading: false,
                isLoaded: true,
                paramsQuery: {
                    search: null,
                    start_date: this.$route.params.startDate ? this.$route.params.startDate : moment().subtract(1, 'months').format('YYYY-MM-DD 17:00:00'),
                    end_date: this.$route.params.endDate ? this.$route.params.endDate : moment().format('YYYY-MM-DD 16:59:59'),
                    orderType: 'normal',
                    per_page: 10,
                    current_page: 1,
                    sort: '',
                    page: 1,
                },
                table: {
                    fields: ProductSalesDetailGoship,
                },
                loadingTable: null,
                OrderQuantity: 0,
                totalSales: 0,
                dataTable: [],
                vuetableFields: false,
                dataFooterFields: [],
            };
        },
        computed: {

        },
        methods: {
            dataManager(sortOrder, pagination) {
                if (sortOrder.length > 0) {
                    this.paramsQuery.sort = sortOrder.map((item) => `${item.sortField}|${item.direction}`).join(',')
                }
                this.setParams();
            },
            onPaginationData(tablePagination) {
                this.$refs.paginationInfo.setPaginationData(tablePagination);
                this.$refs.pagination.setPaginationData(tablePagination);
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page);
            },
            onInitialized(fields) {
                this.vuetableFields = fields.filter((field) => field.togglable);
            },
            search() {
                this.setParams();
            },
            vuetableLoaded() {
                // this.onload = false;
            },
            vuetableLoading() {},
            setPerPage(perPage) {
                this.paramsQuery.current_page = 1;
                this.$refs.vuetable.currentPage = 1;
                this.paramsQuery.per_page = perPage;
                this.setParams();
            },
            async setParams() {
                    this.loading = true;

                    this.paramsQuery.page = this.$refs.vuetable.currentPage;
                    let queryString = "";
                    let id = this.$route.params.id;
                    if (this.paramsQuery) {
                        queryString += "?" + $.param(this.paramsQuery);
                    }
                    let data = await Api.Report.getProductSalesDetailGosell(queryString, id)
                    // console.log(data.data.data);
                    this.OrderQuantity = data.data.countOrderQuantity;
                    this.totalSales = data.data.totalSales;
                    // this.count.all = data.data.data.length;
                    this.$refs.vuetable.setData(data.data.data);
                    this.dataTable = data.data.data;
                    this.loading = false;
                    this.onload = false;
            },
            bankLogo: function (saleOrderPayment) {
                let image = this.$storeIndex.getImageSrc('bank/none');
                if (saleOrderPayment.length > 0) {
                    const [firstSalesOrderPayment] = saleOrderPayment;
                    if (firstSalesOrderPayment.bank_account) {
                        if (firstSalesOrderPayment.bank_account.bank.logo !== null) {
                            image = firstSalesOrderPayment.bank_account.bank.logo;
                        }
                    }
                }
                return image;
            },
        },
        computed: {
            totalqty() {
                let dataTable = this.dataTable.data;
                if (dataTable && dataTable.length > 0) {
                    let totalCount = dataTable.map((item) => { return item.qty });

                    return totalCount.reduce((total, item) => total + item);
                }else {
                    return 0
                }
            },
            totalSale() {
                let dataTable = this.dataTable.data;
                if (dataTable && dataTable.length > 0) {
                    let totalData = dataTable.map((item) => { return parseFloat(item.totalSales); });

                    return totalData.reduce((total, item) => total + item);
                }else {
                    return 0
                }
            },
            totalNormals() {
                let dataTable = this.dataTable.data;
                if (dataTable && dataTable.length > 0) {
                    return dataTable.reduce((sum, item) => sum + +item.totalNormal, 0)
                }else {
                    return 0
                }
            },
            footerTableFields() {
                if(this.vuetableFields !== false) {
                    return this.$refs.vuetable.tableFields;
                }else {
                    return [];
                }
            }
        },
        watch: {
            footerTableFields: {
                handler: function (nval, oval) {
                    let newFooterTableArray = [];
                    nval.forEach(element => {
                        if (element.visible === true) {
                            newFooterTableArray.push(element)
                        }
                    });
                    this.$nextTick(() => {
                        this.dataFooterFields = newFooterTableArray;
                    });
                },
                deep: true
            }
        },
        async mounted() {
            // console.log(this.$route.params)
            this.onload = true;
        },
        created() {
        },
        filters: {
            formatNumber: function (value) {
                if (value == '-') {
                    value = 0;
                }
                return numeral(value).format("0,0.00");
            },
            formatDate: function(value) {
                if (value) {
                    return moment(String(value)).format('DD/MM/YYYY')
                }
}
        },
    };

</script>
<style>
    .header-title {
        margin-bottom: 0.1rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/ProductSalesDetail.vue